import { personalTelecelPlayChildren } from "./personalTelecelPlayChildren";
import { enterpriseTelecelPlayChildren } from "./enterpriseTelecelPlayChildren";
import {fixedTelecelPLayChildren} from "./fixedTelecelPLayChildren"
import {mobileTelecelPlayChildren} from "./mobileTelecelPlayChildren"

export const personal_sub_menu = [
  {
    label: "Mobile",
    url: "/personal/mobile/",
    children: [
      {
        label: "Offers",
        icon: "top-up-system",
        url: "#",
        children: [
          {
            label: "Mobile Offers",
            url: "/personal/mobile/",
            children: [],
          },
          {
            label: "Bundles",
            url: "/personal/mobile/offers/bundles/",
            children: [],
          },
          {
            label: "Tarrifs & International Offers",
            url: "/personal/mobile/offers/international-offers/",
            children: [],
          },
          {
            label: "Airtime Top Up",
            url: "/personal/mobile/offers/top-up/",
            children: [],
          },
          {
            label: "Telecel Black",
            url: "/personal/mobile/offers/telecel-black/",
            children: [],
          },
        ],
      },
      {
        label: "Shop",
        url: "#",
        icon: "Career",
        children: [
          {
            label: "Phones",
            url: "/personal/mobile/shop/devices/",
            children: [],
          },
          {
            label: "Connected Devices",
            url: "/personal/mobile/shop/connected-devices/",
            children: [],
          },
          // {
          //   label: "Request for Device",
          //   url: "#",
          //   children: [],
          // },
        ],
      },
      {
        label: "Promos",
        url: "#",
        icon: "Request Re-location Image",
        children: [
          {
            label: "More Money Promo", 
            url: "/personal/mobile/promos/more-money-promo/",
            children: [],
          },
          // {
          //   label: "Business",
          //   url: "/personal/broadband/broadband-business-application",
          //   children: [],
          // },
        ],
      },
    ],
  },
  {
    label: "Broadband",
    url: "/personal/broadband/",
    children: [
      {
        label: "Offers",
        icon: "top-up-system",
        url: "#",
        children: [
          {
            label: "Broadband Offers",
            url: "/personal/broadband/",
            children: [],
          },
          {
            label: "Standard Plans",
            url: "/personal/broadband/offers/standard-bundles/",
            children: [],
          },
          {
            label: "One Family",
            url: "/personal/broadband/offers/one-family/",
            children: [],
          },

          {
            label: "Flexi",
            url: "/personal/broadband/offers/flexi-offers/",
            children: [],
          },
          // {
          //   label: "Special Offers",
          //   url: "/personal/broadband/offers/special-offers-and-promotions/",
          //   children: [],
          // },
        ],
      },
      {
        label: "Promos",
        url: "#",
        icon: "Request Re-location Image",
        children: [
          {
            label: "2 Moorch Family",
            url: "/personal/broadband/promos/2-moorch-family-offer/",
            children: [],
          },
          // {
          //   label: "Business",
          //   url: "/personal/broadband/broadband-business-application",
          //   children: [],
          // },
        ],
      },
      {
        label: "Self Service",
        url: "#",
        icon: "Career",
        children: [
          {
            label: "Apply for Broadband",
            url: "https://play.telecel.com.gh/pap/index.php?sid=check",
            children: [],
          },
          {
            label: "Bill Payment",
            url: `${process.env.play_base_url}/pay/`,	
            children: [],
          },
          // {
          //   label: "Request for Relocation",
          //   url: "#",
          //   children: [],
          // },
          // {
          //   label: "Report a fault",
          //   url: "#",
          //   children: [],
          // },
        ],
      },
    ],
  },
  {
    label: "Telecel Cash",
    url: "/personal/telecel-cash/",
    children: [
      {
        label: "Offers",
        icon: "register",
        url: "#",
        children: [
          {
            label: "Telecel Cash Offers",
            url: "/personal/telecel-cash/",
            children: [],
          },
          {
            label: "Telecel Cash Tariffs",
            url: "/personal/mobile/offers/tariffs?tariffID=cash",
            children: [],
          },
        ],
      },
      {
        label: "Transfer & Payments",
        url: "#",
        icon: "roaming-system",
        children: [
          {
            label: "ATM Withdrawal",
            url: "/personal/telecel-cash/atm-withdrawal/",
            children: [],
          },
          {
            label: "Bank Services",
            url: "/personal/telecel-cash/bank-services/",
            children: [],
          },
          {
            label: "International Money Transfer",
            url: "/personal/telecel-cash/international-money-transfer/",
            children: [],
          },
          {
            label: "Airtime Purchase",
            url: "/personal/telecel-cash/airtime-purchase/",
            children: [],
          },
          {
            label: "POS Payments",
            url: "/personal/telecel-cash/pos-payments/",
            children: [],
          },
          {
            label: "TV Subscriptions",
            url: "/personal/telecel-cash/tv-subscriptions/",
            children: [],
          },
          {
            label: "Ghana Water Company Bills",
            url: "/personal/telecel-cash/utility/",
            children: [],
          },
          {
            label: "Mobile Money Interoperability",
            url: "/personal/telecel-cash/mobile-money-interoperability/",
            children: [],
          },
        ],
      },
      {
        label: "Register",
        url: "#",
        icon: "roaming-system",
        children: [
          {
            label: "Merchant Registration",
            url: "/personal/telecel-cash/merchant-registration/",
            children: [],
          },
        ],
      },
      {
        label: "Loans & Overdrafts",
        url: "#",
        icon: "roaming-system",
        children: [
          {
            label: "Telecel Cash Overdraft",
            url: "/personal/telecel-cash/telecel-cash-overdraft/",
            children: [],
          },
          {
            label: "Ready Loan",
            url: "/personal/telecel-cash/ready-loan/",
            children: [],
          },
        ],
      },
      {
        label: "Insurance",
        url: "#",
        icon: "roaming-system",
        children: [
          {
            label: "MiFuture",
            url: "/personal/telecel-cash/miFuture/",
            children: [],
          },
          {
            label: "MeBanbo Funeral Insurance",
            url: "/personal/telecel-cash/mebanbo-funeral-insurance/",
            children: [],
          },
          {
            label: "Cosmopolitan Insurance",
            url: "/personal/telecel-cash/cosmopolitan-insurance/",
            children: [],
          },
          {
            label: "SafeNet Insurance",
            url: "/personal/telecel-cash/safenet-insurance/",
            children: [],
          },
          {
            label: "Travel Companion",
            url: "/personal/telecel-cash/travel-companion/",
            children: [],
          },
        ],
      },
    ],
  },
  {
    label: "Telecel Play",
    url: `${process.env.play_base_url}/dashboard/`,
    children: (userType) => {
      if (userType === "enterprise") {
        return enterpriseTelecelPlayChildren;
      } else if (userType === "fixed") {
        return fixedTelecelPLayChildren;
      } else if (userType === "mobile") {
        return mobileTelecelPlayChildren;
      } else {
        return personalTelecelPlayChildren;
      }
    },
  },
  {
    label: "Support",
    url: "https://support.telecel.com.gh/",
    children: [],
  },
];
